export const getPrivacyLink = (privacyLink: string, newsletterLink: string): string => {
    return privacyLink.replace(/href="(.*?)"/g, `target="_blank" href="${newsletterLink}"`);
};
